import { render, staticRenderFns } from "./LaudoAgricolaModal.vue?vue&type=template&id=2390c756&scoped=true&lang=pug"
import script from "./LaudoAgricolaModal.vue?vue&type=script&lang=js"
export * from "./LaudoAgricolaModal.vue?vue&type=script&lang=js"
import style0 from "./LaudoAgricolaModal.vue?vue&type=style&index=0&id=2390c756&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2390c756",
  null
  
)

export default component.exports